/**
 * ActionButton Component
 * Styled icon button for actions (delete, edit, etc.)
 */
import React from "react";
import PropTypes from "prop-types";
import "./ActionButton.scss";

export const ActionButton = ({
  icon: Icon,
  onClick,
  disabled = false,
  variant = "default", // default, danger, primary
  size = "normal", // small, normal
  title,
  className = "",
}) => {
  return (
    <button
      className={`action-button action-button--${variant} action-button--${size} ${className}`}
      onClick={onClick}
      disabled={disabled}
      title={title}
      type="button"
    >
      {Icon && <Icon />}
    </button>
  );
};

ActionButton.propTypes = {
  icon: PropTypes.elementType.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf(["default", "danger", "primary"]),
  size: PropTypes.oneOf(["small", "normal"]),
  title: PropTypes.string,
  className: PropTypes.string,
};
